<template>
    <div 
        v-if="data"
        class="grid"
    >
        <Toolbar
            :option="optionSelected"
            :toolbar-items="toolbarItems"
            @accionPopup="addItem"
            @accionRefresh="refreshGrid"
            @accionExport="exportToXls"
        />
        <DxDataGrid 
            ref="usersList"
            :data-source="data"
            :show-borders="true"
            key-expr="id"
            :allow-column-resizing="true"
            :column-auto-width="true"
            @editing-start="editElement"
            @row-removing="deleteElement"
        >
            <DxPaging :enabled="false" />
            <DxEditing
                :allow-updating="true"
                :allow-deleting="true"
                mode="popup"
            />
            <!-- 
            -- "field.name" debe coincidir con el "data.KEY"
             -->
            <DxColumn 
                v-for="(column, index) in columns"
                :data-type="column.type"
                :key="index"
                :caption="column.label"
                :data-field="column.name"
                :alignment="column.alignment"
            />  
            <DxFilterRow :visible="true" />
            <DxColumnFixing :enabled="true" />
        </DxDataGrid>
        <Pager
            v-if="data"
            :total-pages="pagQuan"
            :total-reg="regQuan"
            :current-page="currentPage"
            @pagechanged="onPageChange"
            :maxVisibleButtons="pagerButtons()"
            :pager-description="!mobile"
        />
         <Popup 
            :show="showPopup"
            @hiddenPopup="popupVisible"
        >
            <template #popup-title>
                {{formTitle}}
            </template>
            <template #popup-content>
                <Form
                    ref="form"
                    :itemSelect="element"
                />
            </template>
        </Popup>
    </div>
</template>

<script>
    /**
     * Importaciones devExtreme
     */
    import { 
        DxDataGrid, 
        DxColumn, 
        DxEditing, 
        DxPaging,
        DxColumnFixing,
        DxFilterRow} from 'devextreme-vue/data-grid';
    import notify from 'devextreme/ui/notify';

    /**
     * Importaciones Vue
     */
    import { useStore } from 'vuex';
    import { computed, ref } from 'vue';

    /**
     * Importaciones de componentes propios
     */
    import Toolbar from './Toolbar';
    import Pager from './Pager';
    import Popup from './Popup';
    import Form from './Form';


    export default {
        name: 'Grid',
        components: {
            DxDataGrid,
            DxColumn,
            DxEditing,
            DxColumnFixing,
            DxFilterRow,
            DxPaging,
            Pager,
            Toolbar,
            Popup,
            Form
        },
        setup() {
            const store = useStore();
            const element = ref();
            const usersList = ref(null);
            const form = ref(null);
            const formTitle = ref(null)

            /**
             * COMPUTED PROPERTIES
             */
            const data = computed( () => store.state.tableItems.data  );
            const optionSelected = computed( () => store.state.optionSelect.text );
            const toolbarItems = computed( () => store.state.tableItems.configuration.toolbar );
            const showPopup = computed( ()=> store.state.showPopup )
            const columns = computed( () => {
                const cols = store.state.tableItems.configuration.grid.fields.map( e => {
                    return e;
                });
                return cols
            });
            const pagQuan = computed( () => store.state.tableItems.meta.pages );
            const regQuan = computed( () => store.state.tableItems.meta.total )
            const mobile = computed( () => store.state.mobile )
            const currentPage = computed( () => { 
                if(store.state.currentPage){
                    return store.state.currentPage
                }
                return 1;
            } );
            const activeForm = computed( () => store.state.activeForm );
            const forms = computed( () => store.state.tableItems.configuration.forms );

            /**
             * METHODS
             */
            const popupVisible = () => {
                forms.value.forEach(el => {
                    if(el.name === activeForm.value){
                        formTitle.value = el.title;
                    }
                });
                store.dispatch('activePopup');
            }

            const editElement = async (e) => {
                e.cancel = true;
                element.value={};
                store.dispatch('changeForm','edit')
                popupVisible();
                const res = await store.dispatch('getItem',{option: store.state.optionSelect.text, item: e.data.id, action: 'update', page: currentPage.value} );
                element.value = res;
                if(element.value.birth_date){
                element.value.birth_date = Date.parse(element.value.birth_date);
                }
                form.value.selectBox()
            }
    
            const deleteElement = (e) => {
    
                const dataValidation =  async () => {
                    const res =  await store.dispatch('removeItem', {option: store.state.optionSelect.text, item: e.data, action: 'remove'})

                    if(res.remove){
                        notify({
                            message: res.msg,
                            type: 'error',
                            displayTime: 2000,
                            width: 100,
                        })
                        return true
                    }
                    notify({
                            message: res.msg,
                            type: 'success',
                            displayTime: 2000,
                            width: 100,
                        })
                    return false
                }

                e.cancel = dataValidation()
            }

            const onPageChange = (page) => {
                store.dispatch('changePage', page)
                store.dispatch('get',{option: store.state.optionSelect.text, page: page})
            }

            const refreshGrid = () => {
                store.dispatch('get',{option: store.state.optionSelect.text, page: currentPage.value})
            }

            const exportToXls = () => {
                usersList.value.instance.exportToExcel();
            }

            const addItem = async () => {
                element.value={};
                popupVisible();
                /**
                 * Fix form.value = NULL!
                 */
                setTimeout(() => {
                    form.value.selectBox();
                }, 100);
            }

            const pagerButtons = () => {
                if(mobile.value){
                    return 2;
                }
                return 3;
            }

            return { 
                columns,
                pagQuan,
                currentPage,
                onPageChange,
                mobile,
                regQuan,
                editElement,
                deleteElement,
                data,
                optionSelected,
                toolbarItems,
                showPopup,
                popupVisible,
                element,
                refreshGrid,
                usersList,
                exportToXls,
                form,
                addItem,
                pagerButtons,
                formTitle
            }
        }
    }
</script>

<style>
    .pager {
        margin-top: 10px;
    }

    .dx-toast-content {
        display: inline-flex;
        justify-content: center;
    }
</style>